// The server's reason, when it sends one: a JSON `reason` string, or a plain-text body.
// Anything else shows the page's own sentence (`failedMessage`, with `{status}` for the status code).
export async function uploadFailureMessage(response: Response, failedMessage: string): Promise<string> {
    const fallback = failedMessage.replace("{status}", String(response.status));
    const text = (await response.text()).trim();
    if (text.length === 0) return fallback;

    if (text.startsWith("{") || text.startsWith("[")) {
        try {
            const parsed = JSON.parse(text) as { reason?: unknown };
            if (parsed && typeof parsed.reason === "string" && parsed.reason.trim().length > 0)
                return parsed.reason.trim();
            return fallback;
        } catch {
            return text;
        }
    }

    return text;
}
